<div class="container py-3">


    <div class="d-flex justify-content-center flex-column">

        <div class="d-flex flex-row justify-content-between">
            <div>
                <h1 class="m-0">{{ titulo }}</h1>
                <span>{{subtitulo}}</span>

            </div>
            <div>
                <button mat-icon-button class="btn" (click)="fechar()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div class="mt-4" *ngIf="videoUrl">
            <iframe class="iframe-video" [src]="videoUrl"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </div>

</div>
